<template>
  <v-data-table
    dense
    :loading="loading"
    loading-text="Buscando información..."
    :headers="headers"
    :items="filteredData"
    :search="search"
    :items-per-page="50"
    class="elevation-2 table__desing-general t able__movements--scroll table__desing-border caption"
    no-results-text="No se han encontrado coincidencias"
  >
    <template #top>
      <div class="d-flex align-center">
        <slot name="table-header" />
        <div class="d-flex align-center ml-auto">
          <search-input
            v-model="search"
            :disabled="loading"
            class="search-input-width mt-4"
          />
        </div>
      </div>
      <title-header-table>
        <span>Detalle de pedidos</span>
      </title-header-table>
    </template>
    <template #footer>
      <alert-prominent
        v-if="hasErrors"
        :disabled-button="loading"
        :with-action="true"
        :max-clicks="5"
        @click="$emit('refreshOrders')"
      />
    </template>
    <template #[`header.orderStatus`]="{ header }">
      <div class="d-flex flex-column align-center">
        {{ header.text }}
        <custom-select
          v-if="statuses"
          v-model="status"
          value="1"
          :options="statuses"
          :disabled="loading"
          theme="red"
        />
      </div>
    </template>
    <template #[`item.managerName`]="{ index, item }">
      <div class="d-flex text-left align-center text-nowrap">
        <span class="font-weight-bold">{{ index + 1 }}</span>
        <span class="ml-2">
          {{ item.managerName }} <br />
          {{ item.territoryName }}
        </span>
      </div>
    </template>

    <template #[`item.salespersonName`]="{ index, item }">
      <div class="d-flex text-left align-center text-nowrap">
        <span class="font-weight-bold">{{ index + 1 }}</span>
        <span class="ml-2">
          {{ item.salespersonName }} <br />
          {{ item.zoneDescription }}
        </span>
      </div>
    </template>
    <template #[`item.totalAmount`]="{ item }">
      {{ formatNumber(item.totalAmount, '$', 0) }}
    </template>
    <template #[`item.orderStatus`]="{ item }">
      <span class="font-weight-bold" :style="`color:${item.orderStatus.color}`">
        {{ item.orderStatus.label }}
      </span>
    </template>
    <template #[`item.customerName`]="{ item }">
      <span class="text-nowrap">
        {{ item.customerName }}
      </span>
    </template>
    <template #[`item.orderReasonId`]="{ item }">
      <tooltip-avatar
        :text="item.orderReasonId"
        :tooltip-text="item.orderReasons"
      />
    </template>
  </v-data-table>
</template>
<script>
  import axios from '@/plugins/axios';
  import numbersFormats from '@/mixins/numbersFormats';

  import TitleHeaderTable from '@/components/tables/TitleHeaderTable.vue';
  import CustomSelect from '@/components/CustomSelect.vue';
  import AlertProminent from '@/components/AlertProminent.vue';
  import TooltipAvatar from '@/components/TooltipAvatar.vue';
  import SearchInput from '@/components/SearchInput.vue';

  export default {
    components: {
      CustomSelect,
      TitleHeaderTable,
      AlertProminent,
      TooltipAvatar,
      SearchInput,
    },
    mixins: [numbersFormats],
    props: {
      items: {
        required: true,
        type: Array,
        default: () => [],
      },
      loading: Boolean,
      hasErrors: Boolean,
    },
    data() {
      return {
        status: -1,
        headers: [
          { text: 'Gerencia', value: 'managerName', align: 'center' },
          { text: 'Zona', value: 'zoneDescription', align: 'center' },
          { text: 'Usuario', value: 'author', align: 'center' },
          { text: 'Número de cliente', value: 'customerId', align: 'center' },
          {
            text: 'Razón social',
            value: 'customerName',
            align: 'center',
          },
          { text: 'Fecha', value: 'orderCreationDate', align: 'center' },
          { text: 'Número de pedido', value: 'orderId', align: 'center' },
          { text: 'Importe', value: 'totalAmount', align: 'center' },
          {
            text: 'Estatus',
            value: 'orderStatus',
            align: 'center',
            sortable: false,
          },
          { text: 'Motivos', value: 'cancelationReason', align: 'center' },
        ],
        search: '',
        statuses: [{ value: -1, label: 'TODOS' }],
      };
    },
    computed: {
      filteredData() {
        return this.status !== -1
          ? this.filterByStatus(this.items)
          : this.items;
      },
    },
    mounted() {
      this.getStatuses();
    },
    methods: {
      filterByStatus(data) {
        return Object.values(data).filter(
          (item) => item.orderStatus.value === this.status
        );
      },
      async getStatuses() {
        try {
          const response = await axios.get('/order-management/statuses');
          this.statuses.push(...response.data);
        } catch (error) {
          this.$toast.error('Error al obtener los estados de los pedidos');
        }
      },
    },
  };
</script>
